// removed by extract-text-webpack-plugin
module.exports = {"invalid-message":"app-pages-VerifyEmail-__VerifyEmail___2B-Vj"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/VerifyEmail/VerifyEmail.css
// module id = 2243
// module chunks = 0